import HiggsPromise from '../utils/higgsPromise';
import {provinceNameFormat} from '../utils/formatter';

/* ------------------------ 地理分布情况 ------------------------ */
// 下拉框接口
export function getAllOptions() {
    return HiggsPromise({
        url: '/index/code',
        transformResponse: function (data) {
            if(data.data && data.data.province) {
                data.data.province.forEach(d => d.value = provinceNameFormat(d.value));
            }
            return data;
        }
    });
}
// 地图数据
export function statisticMap(data, cancel) {
    return HiggsPromise({
        url: '/csrc/supervision/company/statistic',
        data,
        cancel
    });
}
// 折线图
export function statisticTrend(data, cancel) {
    return HiggsPromise({
        url: '/csrc/supervision/company/statistic/trend',
        data,
        cancel
    });
}
// 饼图
export function statisticPie(data, cancel) {
    return HiggsPromise({
        url: '/csrc/supervision/company/statistic/pie',
        data,
        cancel
    });
}

/* ------------------------ 行业分布情况 ------------------------ */
// 散点图
export function getIndustryCensus(data, cancel) {
    return HiggsPromise({
        url: '/csrc/supervision/industry/company/census/search',
        data,
        cancel
    });
}
// 排名
export function getIndustryRank(data, cancel) {
    return HiggsPromise({
        url: '/csrc/supervision/industry/company/rank',
        data,
        cancel
    });
}
// 走势
export function getIndustryTrend(data, cancel) {
    return HiggsPromise({
        url: '/csrc/supervision/industry/trend',
        data,
        cancel
    });
}
// 地域分布
export function getIndustrySpread(data, cancel) {
    return HiggsPromise({
        url: '/csrc/supervision/industry/area/spread',
        data,
        cancel
    });
}

/* ------------------------ 公司排名情况 ------------------------ */
export function getComRank(data) {
    return HiggsPromise({
        url: '/csrc/supervision/company/score/rank',
        data
    });
}

export function getComVaryRank(data, cancel) {
    return HiggsPromise({
        url: '/csrc/supervision/company/score/vary/rank',
        data,
        cancel
    });
}

/* ------------------------ 评分分布情况 ------------------------ */
export function getScoreSpread(data) {
    return HiggsPromise({
        url: '/csrc/supervision/score/spread',
        data
    });
}

/* ------------------------ 查询公司 ------------------------ */
// 搜索接口
export function getCompanyStatisticReport(data, cancel) {
    return HiggsPromise({
        url: '/csrc/supervision/company/statistic/report',
        data,
        cancel
    });
}

// 报表链接
export function getReportView(data, cancel) {
    return HiggsPromise({
        url: '/csrc/supervision/report/view',
        data,
        cancel
    });
}

// 分数雷达图
export function statisticReportSummary(data, cancel) {
    return HiggsPromise({
        url: '/csrc/supervision/company/report/summary',
        data,
        cancel
    });
}

// 折线图
export function statisticReportTrend(data, cancel) {
    return HiggsPromise({
        url: '/csrc/supervision/industry/company/trend',
        data,
        cancel
    });
}

/* ------------------------ 监管动态 ------------------------ */
// 最新动态
export function noticeList(data) {
    return HiggsPromise({
        url: '/csrc/supervision/notice/list',
        data
    });
}

// 最新动态详情
export function noticeDetail(data) {
    return HiggsPromise({
        url: '/csrc/supervision/notice/detail',
        data
    });
}

// 监管文件
export function dynamicLetter(data) {
    return HiggsPromise({
        url: '/csrc/supervision/company/dynamic/letter',
        data
    });
}

// 近季度监管文件发布情况
export function quarterPublish() {
    return HiggsPromise({
        url: '/csrc/supervision/quarter/publish'
    });
}

/* ------------------------ 公司风险动态提示 ------------------------ */
// 最新动态
export function riskHintTrends(data) {
    return HiggsPromise({
        url: '/csrc/supervision/company/abnormal/news/list',
        data
    });
}

// 最新公告
export function announcementApi(data) {
    return HiggsPromise({
        url: '/csrc/supervision/company/abnormal/latest/notice/list',
        data
    });
}



// WEBPACK FOOTER //
// ./src/services/regulatoryStatistical.js